import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import classNames from 'classnames';
import { getApiUrl } from '../../../utils/apiConfig';


const EstadoObraDropdown = ({ selectedObra, setSelectedObra, disabled }) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);
  const [estadoOptions, setEstadoOptions] = useState([]);

  useEffect(() => {
    const fetchEstados = async () => {
      try {
        const res = await axios.get(getApiUrl('/api/estadoObra'));
        const estados = res.data.map((estado) => ({
          value: estado.EstadoObra,
          label: estado.EstadoObra,
          color: '#eee',
        }));
        setEstadoOptions(estados);
      } catch (err) {
        console.error('Error al cargar estados de oferta:', err);
      }
    };

    fetchEstados();
  }, []);

  // const selected = estadoOptions.find((opt) => opt.value === selectedObra?.EstadoObra) || { value: '', label: '', color: '#eee' };

  const selected = {
    value: selectedObra?.EstadoObra || '',
    label: selectedObra?.EstadoObra || '',
    color: '#eee'
  };

  const placeholder = 'Selecciona estado';
  const hasSelection = Boolean((selectedObra?.EstadoObra || '').trim());

  // Cerrar dropdown al hacer clic fuera
  useEffect(() => {
    if (!isOpen) return;
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div className="relative w-full" ref={containerRef}>
      <label className="block mb-1 text-xs font-medium text-gray-700 truncate">
        Estado Obra*
      </label>
      <button
        disabled={disabled}
        onClick={() => setIsOpen(!isOpen)}
        title={hasSelection ? selected.label : placeholder}
        className="DropDownName w-full p-2 border rounded shadow-sm bg-white text-left flex justify-between items-center"
      >
        <span className={`truncate ${hasSelection ? '' : 'text-gray-400'}`}>
          {hasSelection ? selected.label : placeholder}
        </span>
        <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>
      {isOpen && (
        <ul className="absolute mt-1 w-full bg-white border rounded shadow-lg max-h-60 overflow-auto" style={{ zIndex: 1100 }} role="listbox">
          <li
            onClick={() => { setSelectedObra({ ...selectedObra, EstadoObra: ''}); setIsOpen(false); }}
            className={`cursor-pointer px-4 py-2 text-sm hover:bg-blue-50 hover:text-blue-700 transition-colors ${!hasSelection ? 'bg-blue-50 text-blue-700 font-medium' : ''}`}
            role="option"
            aria-selected={!hasSelection}
          >
            {placeholder}
          </li>
          {estadoOptions.map(option => (
            <li
              key={option.value}
              onClick={() => {
                setSelectedObra({ ...selectedObra, EstadoObra: option.value});
                setIsOpen(false);
              }}
              className={classNames(
                'cursor-pointer px-4 py-2 text-sm hover:bg-blue-50 hover:text-blue-700 transition-colors',
                { 'bg-blue-50 text-blue-700 font-medium': (selectedObra.EstadoObra?.trim() || '') === option.value }
              )}
              role="option"
              aria-selected={(selectedObra.EstadoObra?.trim() || '') === option.value}
            >
              {option.label}
            </li>
          ))}
        </ul>

      )}
    </div>
  );
};

export default EstadoObraDropdown;
